module.exports = __webpack_public_path__ + "img/micro.57c00002.jpg";